import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { INewsChatViewDTO } from '../../../libs/coreapi-dto/service/newsChat';
import { NewsFiltersValue } from '../components/newsFilters/NewsFilters';
import { getNewsDate } from '../utils/newsUtils';

const MIN_SEARCH_LENGTH = 3;

export const useFilteredNews = (
    news: INewsChatViewDTO[],
    filters: NewsFiltersValue
) => {

    return useMemo(() => {

        return news.filter(item => {
            const search = filters.search.trim().toLowerCase();
            const shouldSearch = search.length >= MIN_SEARCH_LENGTH;

            if (shouldSearch) {
                const text = [
                    item.subject,
                    item.description,
                ]
                    .join(' ')
                    .toLowerCase();

                if (!text.includes(search)) {
                    return false;
                }
            }


            if (
                filters.priorities.length &&
                !filters.priorities.includes(item.priority)
            ) {
                return false;
            }

            if (filters.startDate) {
                const newsDate = getNewsDate(item);

                if (
                    newsDate.isValid &&
                    newsDate.startOf('day') < filters.startDate.startOf('day')
                ) {
                    return false;
                }
            }

            if (filters.dueDate) {
                const newsDate = getNewsDate(item);

                if (
                    newsDate.isValid &&
                    newsDate.startOf('day') > filters.dueDate.endOf('day')
                ) {
                    return false;
                }
            }

            return true;

        });

    }, [news, filters]);

};